export const initMobileNav = () => {
  const navRoot = document.querySelector('.main-navigation');
  const toggleBtn = document.querySelector('[data-nav-toggle]');
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) return;
  console.log('[MobileNav] Init triggered');

  if (!navRoot || !toggleBtn || window.innerWidth >= 1024) {
    console.log('[MobileNav] Skipped - Conditions not met:', { navRoot, toggleBtn, width: window.innerWidth });
    return;
  }

  const navPanel = navRoot.querySelector('.menu');
  let currentMenu = navPanel;
  let isTransitioning = false;
  let isOpen = false;

  const focusableSelectors = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
  const trapFocus = (container) => {
    const focusableEls = container.querySelectorAll(focusableSelectors);
    const first = focusableEls[0];
    const last = focusableEls[focusableEls.length - 1];

    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  };

  const handleEscape = (e) => {
    if (e.key === 'Escape') closeNav();
  };

  const openNav = () => {
    if (isTransitioning || isOpen) return;
    isTransitioning = true;
    console.log('[MobileNav] Opening menu');
    navRoot.classList.add('is-open');
    document.body.classList.add('nav-open');
    toggleBtn.setAttribute('aria-expanded', true);
    document.addEventListener('keydown', handleEscape);
    trapFocus(navRoot);
    isOpen = true;
    setTimeout(() => { isTransitioning = false; }, 350);
  };

  const closeNav = () => {
    if (isTransitioning || !isOpen) return;
    isTransitioning = true;
    console.log('[MobileNav] Closing menu');
    navRoot.classList.remove('is-open');
    document.body.classList.remove('nav-open');
    toggleBtn.setAttribute('aria-expanded', false);
    document.removeEventListener('keydown', handleEscape);
    isOpen = false;
    setTimeout(() => { isTransitioning = false; }, 350);
  };

  toggleBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    console.log('[MobileNav] Toggle clicked');
    isOpen ? closeNav() : openNav();
  });

  navRoot.querySelectorAll('[data-submenu-trigger]').forEach(trigger => {
    const parent = trigger.closest('li');
    const submenu = parent?.querySelector('.sub-menu');
    if (!submenu) return;

    const submenuId = submenu.dataset.submenuId || `submenu-${Math.random().toString(36).substr(2, 9)}`;
    submenu.dataset.submenuId = submenuId;
    trigger.setAttribute('aria-controls', submenuId);

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('[MobileNav] Submenu trigger clicked');
      currentMenu.classList.add('is-sliding-out');
      submenu.style.display = 'block';
      submenu.style.transform = 'translateX(100%)';

      requestAnimationFrame(() => {
        currentMenu.style.transform = 'translateX(-100%)';
        submenu.style.transition = 'transform 0.3s ease';
        submenu.style.transform = 'translateX(0)';
      });

      submenu.setAttribute('aria-hidden', 'false');
      currentMenu = submenu;
      trapFocus(submenu);
    });
  });

  navRoot.querySelectorAll('.menu-back').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('[MobileNav] Submenu back clicked');
      const submenu = btn.closest('.sub-menu');
      const parentMenu = submenu?.parentElement.closest('.menu, .sub-menu');
      if (!submenu || !parentMenu) return;

      submenu.style.transform = 'translateX(0)';
      submenu.style.transition = 'transform 0.3s ease';
      submenu.style.transform = 'translateX(100%)';

      submenu.addEventListener('transitionend', () => {
        submenu.style.display = 'none';
        submenu.classList.remove('is-active');
        submenu.removeAttribute('style');
        submenu.setAttribute('aria-hidden', 'true');
      }, { once: true });

      parentMenu.style.display = 'block';
      parentMenu.style.transform = 'translateX(-100%)';

      requestAnimationFrame(() => {
        parentMenu.style.transition = 'transform 0.3s ease';
        parentMenu.style.transform = 'translateX(0)';
      });

      parentMenu.setAttribute('aria-hidden', 'false');
      currentMenu = parentMenu;
      trapFocus(parentMenu);
    });
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 1024) {
        console.log('[MobileNav] Window resized - Resetting nav');
        closeNav();
        navRoot.querySelectorAll('.sub-menu').forEach(menu => {
          menu.classList.remove('is-active');
          menu.removeAttribute('style');
          menu.setAttribute('aria-hidden', 'true');
        });
      }
    }, 200);
  });
};
